export default __webpack_public_path__ + "static/media/arrow-up-slim.5afdcb83.svg";